import { ApiAddress } from '@/services/apis'
import { ID } from '@/services/common.model'
import request from '@/services/request'
import md5 from 'blueimp-md5'
import { User } from './user.model'

export function getUser(): Promise<User.Info> {
  return request.get(ApiAddress.USER)
}

export function getUserById(id: ID): Promise<User.Info> {
  return request.get(ApiAddress.USER_ID, { params: { id } })
}

export function updateUser(data) {
  return request.put(ApiAddress.USERS, data)
}

export function queryUsers(query: string): Promise<User.Info[]> {
  return request.get(ApiAddress.USERS, { params: { query } })
}

export function queryUsersAndOrgs(query: string): Promise<{ users: User.Info[]; organizations: any[] }> {
  return request.get(ApiAddress.USERS_ORGS, { params: { query } })
}

export function changePassword(data) {
  data.oldPassword = md5(data.oldPassword)
  data.newPassword = md5(data.newPassword)
  return request.put(ApiAddress.USERS_PASSWORD, data)
}

export function projectTypeItem(projectId): Promise<any> {
  return request.get(ApiAddress.PROJECT_TYPE_ITEM, { params: { projectId } })
}
